import { useState } from "react";

import { 
    actualizarHorario, 
    eliminarHorario, 
    crearHorario, 
    obtenerHorario, 
    obtenerHorarios,
    obtenerHorariosCategoria } 
from "../Services/Horarios";

export const useHorarios = () => {
    const [horarios, setHorarios] = useState([]);
    const [horario, setHorario] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const cargarHorarios = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await obtenerHorarios();

            setHorarios(response.data || []);
            

            return response;
        } catch (error) {
            console.error("Error al obtener horarios:", error);
            setError(error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    

    const cargarHorario = async (id) => {
        try {
            setLoading(true);
            setError(null);

            const response = await obtenerHorario(id);

            setHorario(response.data);

            return response;
        } catch (error) {
            console.error("Error al obtener horario:", error);
            setError(error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const guardarHorario = async (formData) => {
        try {
            setLoading(true);
            setError(null);

            const response = await crearHorario(formData);

            await cargarHorarios();

            return response;
        } catch (error) {
            console.error("Error al crear horario:", error);
            setError(error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const editarHorario = async (id, formData) => {
        try {
            setLoading(true);
            setError(null);

            const response = await actualizarHorario(id, formData);

            await cargarHorarios();

            return response;
        } catch (error) {
            console.error("Error al actualizar horario:", error);
            setError(error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const borrarHorario = async (id) => {
        try {
            setLoading(true);
            setError(null);

            const response = await eliminarHorario(id);

            await cargarHorarios();

            return response;
        } catch (error) {
            console.error("Error al eliminar horario:", error);
            setError(error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    return {
        horarios,
        horario,
        loading,
        error,

        cargarHorarios,
        cargarHorario,

        guardarHorario,
        editarHorario,
        borrarHorario,

        setHorario,
    };
};

export const useHorariosCategoria = () => {

    const [categorias, setCategorias] = useState([]);
    const [loadingCat, setLoadingCat] = useState(false);
    const [errorCat, setErrorCat] = useState(null);


    const cargarCategorias = async () => {

        try {

            setLoadingCat(true);
            setErrorCat(null);

            const response = await obtenerHorariosCategoria();

           

            setCategorias(response.categorias || []);

            return response;

        } catch (error) {

            console.error(
                "Error al obtener Categorias:",
                error
            );

            setErrorCat(error);

            throw error;

        } finally {

            setLoadingCat(false);

        }
    };


    return {
        categorias,
        loadingCat,
        errorCat,
        cargarCategorias,
    };
};
